import type {RefObject} from 'react'

import {
  useArtifactsPanelActions,
  useArtifactsPanelReturnFocusRef,
  useArtifactsPanelState,
} from './ArtifactsPanelContext'
import {ArtifactsPanelShell} from './ArtifactsPanelShell'
import {ArtifactsSidePanelEmbedded} from './ArtifactsSidePanelEmbedded'

export {useEmbeddedAvailable} from './ArtifactsPanelShell'

export function ArtifactsPanel({
  mode = 'responsive',
  activeTabRef,
  editable = false,
  navigation = 'close',
}: {
  mode?: 'responsive' | 'docked' | 'overlay'
  activeTabRef?: RefObject<HTMLButtonElement | null>
  editable?: boolean
  navigation?: 'back' | 'close'
}) {
  const {activeArtifactId, activeArtifact, tabs} = useArtifactsPanelState()
  const {activate, closePanel, closeTab, editArtifact, promoteOverflow} = useArtifactsPanelActions()
  const returnFocusRef = useArtifactsPanelReturnFocusRef()
  const props = {
    open: activeArtifactId !== null,
    onClose: closePanel,
    tabs,
    activeId: activeArtifactId,
    activeArtifact,
    onEdit: editable ? editArtifact : undefined,
    onActivate: activate,
    onPromoteOverflowTab: promoteOverflow,
    onCloseTab: closeTab,
    returnFocusRef,
  }

  if (mode === 'docked') {
    return <ArtifactsSidePanelEmbedded {...props} activeTabRef={activeTabRef} docked navigation={navigation} />
  }

  return <ArtifactsPanelShell {...props} forceOverlay={mode === 'overlay'} />
}
